import { TextField, withStyles } from '@material-ui/core'

const AppTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'var(--primary-color)'
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: 'var(--primary-color)'
      },
      '&.Mui-focused fieldset': {
        borderColor: 'var(--primary-color)'
      }
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 14px'
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 10px) scale(1)'
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)'
    },
    '& .MuiOutlinedInput-multiline': {
      padding: '8px 14px'
    }
  }
})(TextField)

export default AppTextField
